<template>
	<footer>
		<div class="footer">
			<div class="footer-left">
				<div class="left-li" v-for="tit in foottit">
					<router-link :to = 'tit.vuelink'>
						<h4>{{tit.name}}</h4>
					</router-link>
					<ul>
						<li class="" v-for="con in footcontent[tit.id].content" @click = 'gotop()'>
							<router-link :to = 'con.vuelink' >
								{{con.name}}
							</router-link>
						</li>
					</ul>
				</div>
				<div class="footer-line">

				</div>
			</div>

			<div class="footer-right">
				<div class="right-img" v-for="img in secondimg" v-bind:class="img.id">
					<img :src="img.imgsrc"/>
					<div class="right-tit">
						<p>扫一扫</p>
						<p>{{img.name}}</p>
					</div>
				</div>
				<div class="right-address">
					<p>地址：惠州市江北云山西路2号帝景国际商务中心C座综合楼718-722室</p>
					<p>电话：0752-2123600</p>
				</div>
			</div>
		</div>
		<div style="clear: both;"></div>
		<div class="footer-lines"></div>
		<div class="footer-bottom">
			<div class="bottom-left">
				<p>友情链接：广东思程科技有限公司 丨 广东思程科技 丨 广东思诚科技有限公司</p>
			</div>
			<div class="bottom-right">
				<p>Copyright © 广东思程科技有限公司. <a href="https://beian.miit.gov.cn">粤ICP备12073207号-1 </a></p>
			</div>
		</div>
	</footer>
</template>

<script>
	export default{
		name: 'vfooter',
		data (){
			return {
				foottit : [
				{id : 0 , name : '关于思程' , vuelink : '/Aboutcom/' + 0},
				{id : 1 , name : '业务中心' , vuelink : '/Technology/' + 0},
				{id : 2 , name : '解决方案' , vuelink : '/Solve/' + 0},
				{id : 3 , name : '案例展示' , vuelink : '/Case/'},
				{id : 4 , name : '我们的产品' , vuelink : '/Product/'+ 0},
				],
				footcontent : [
				{content : [{name : '公司简介' , vuelink : '/Aboutcom/' + 0},{name : '组织框架' , vuelink : '/Aboutcom/' + 1},{name : '企业文化' , vuelink : '/Aboutcom/' + 2},{name : '资质荣誉' , vuelink : '/Aboutcom/' + 3},{name : '新闻资讯' , vuelink : '/Aboutcom/' + 4}]},
				{content : [{name : '服务领域' , vuelink : '/Technology/' + 0},{name : '业务模式' , vuelink : '/Technology/' + 1},{name : '技术领域' , vuelink : '/Technology/' + 2}]},
				{content : [{name : '解决方案' , vuelink : '/Solve/'+ 0}]},
				{content : [{name : '案例展示' , vuelink : '/Case/'}]},
				{content : [{name : '我们的产品' , vuelink : '/Product/'+ 0}]},
				],
				secondimg : [
				{id : 0 , imgsrc : 'static/img/2wm_wx.png' , name : '思程微信公众号'},
				{id : 1 , imgsrc : 'static/img/2wm_gs.png' , name : '思程手机官网'},
				]
			}
		},
		methods : {
			gotop(){
				window.scrollTo(0,0)
			},
		}
	}
</script>

<style>
	ul{
     margin:0;
     border:0;
     padding:0;
}
	footer{
		position: relative;
		width: 100%;
		clear: both;
		background: url(../../static/img/footer.jpg) repeat-y;
		overflow: hidden;
	}
	.footer{
		margin: 0px auto;
		position: relative;
		clear: both;
		width: 85%;
		padding: 20px 0 10px;
	}
	.footer-left{
		width: 60%;
		position: relative;
		clear: both;
		display: inline-block;
	}
	.left-li{
		position: relative;
		display: inline-block;
		width: 19%;
		vertical-align: top;
    color: #aaaaaa;
    text-align: left;
	}
	.left-li li{
		list-style: none;
		font-size: 12px;
		padding: 7.5px 0;
	}
	.footer-left h4{
		color: #fff;
		font-size: 16px;
		margin-bottom: 12.5px;
	}
	.left-li ul{
    -webkit-margin-before: 0em;
    -webkit-margin-after: 0em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 0px;
    -moz-margin-start: 0;
	-moz-margin-end: 0;
	-moz-padding-end: 0;
	-moz-padding-start: 0;
	}
	.left-li ul li a{
		text-decoration: none;
		color: #aaa;
	}
	.footer-line{
		border-left:1px solid #aaaaaa ;
		opacity: 0.3;
		height: 205px;
		position: absolute;
		display: inline-block;
		margin-left: 10px;
	}
	.footer-lines{
		border-bottom:1px solid #aaaaaa ;
		opacity: 0.3;
		height: 2px;
		width: 81%;
		margin: 0 auto;
	}
	.footer-right{
		position: relative;
		display: inline-block;
		clear: both;
		width: 38%;
		top: 8px;
		left: 20px;
	}
	.right-img{
		width: 47%;
		display: inline-block;
		position: relative;
	    vertical-align: text-top;
	    text-align: left;
	    left: 13px;
	    margin-right: 9px;
	}
	.right-img img{
		width: 80px;
	}
	.right-tit{
		position: absolute;
		color: #FFFFFF;
		display: inline-block;
		margin-left: 10px;
		top: 20px;
		text-align: left;
		width: 300px;
	}
	.right-tit p{
		font-size: 12px;
	}
	.right-address{
		position: absolute;
	    clear: both;
	    display: inline-block;
	    width: 100%;
	    text-align: left;
	    top: 122px;
	    left: 13px;
	}
	.right-address p{
		color: #FFFFFF;
		font-size: 12px;
	}
	.footer-bottom{
		position: relative;
		clear: both;
		padding: 10px 0 20px;
		margin: 0 auto;
		width: 83%;
	}
	.footer-bottom p{
		font-size: 12px;
		color: #AAAAAA;
	}
	.bottom-left{
		position: relative;
		display: inline-block;
		text-align: left;
		width: 50%;
		top: 5px;
	}
	.bottom-right{
		position: relative;
		display: inline-block;
		text-align: right;
		width: 48%;
		top: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue